import { Box, styled } from '@mui/material';

export const SignatureSection = styled(Box)(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`,
  padding: theme.spacing(2),
  marginBottom: theme.spacing(2),
  backgroundColor: theme.palette.mode === 'dark' ? '#2c2c2c' : '#ffffff',

  '@media print': {
    backgroundColor: '#ffffff !important',
    color: '#333333 !important',
    borderColor: '#e0e0e0 !important',
    pageBreakInside: 'avoid',

    // Hide form fields
    '& .MuiTextField-root, & .MuiInputBase-root, & input': {
      display: 'none !important',
    },
  },
}));
